'use client'

import { ReactNode } from 'react'

type SmoothScrollButtonProps = {
  children: ReactNode
  targetId: string
  className?: string
}

export default function SmoothScrollButton({ children, targetId, className }: SmoothScrollButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    const element = document.getElementById(targetId)
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start',
        inline: 'nearest'
      })
    }
  }

  return (
    <button className={className} onClick={handleClick}>
      {children}
    </button>
  )
}
